import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

/* eslint-disable @angular-eslint/no-input-rename,@angular-eslint/no-output-on-prefix */
@Directive({
  selector: '[muiClickOutside]',
  standalone: true
})
export class MuiClickOutsideDirective {
  @Input('muiClickOutsideExclude')
  excluded = '';

  @Output()
  muiClickOutside = new EventEmitter<MouseEvent>();

  constructor(private _elementRef: ElementRef) {}

  private static getExcludeList(elementsToExclude: string): string[] {
    return elementsToExclude.split(' ');
  }

  @HostListener('document:click', ['$event', '$event.target'])
  onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) {
      return;
    }
    const clickedInside = this._elementRef.nativeElement.contains(targetElement);
    const excludedList = MuiClickOutsideDirective.getExcludeList(this.excluded);
    const targetIsExcluded = excludedList.some((excluded) => targetElement.classList.contains(excluded));
    if (!(clickedInside || targetIsExcluded)) {
      this.muiClickOutside.emit(event);
    }
  }
}
